import * as React from 'react';
import { GeoSwitcherButtonsContainer } from '../GeoSwitcherButtonsContainer';
import { GeoSuggestContainer } from '../../../../../../shared/filters/components/geo_suggest/container';

export const GeoContainer: React.FC = () => {
  return <GeoSuggestContainer rightAddon={<GeoSwitcherButtonsContainer />} redesign />;
};
